module.exports = __webpack_public_path__ + "public/images/slider/ferdman.1ffef38dba9b09e1ac4b163b3e36cebc.png";